import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './LegalPage.css';

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-inner">
        <Link to="/" className="legal-back">← Back to Home</Link>
        <h1 className="legal-title">Terms &amp; Conditions</h1>
        <p className="legal-updated">Last updated: May 20, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By downloading, installing, or using Lexira ("the App"), you agree to be bound by these Terms and Conditions. If you do not agree, do not use the App.</p>

        <h2>2. Eligibility</h2>
        <p>The App is intended for users aged 13 and older. By using the App, you confirm that you meet this age requirement. Users under 18 must have parental or guardian consent.</p>

        <h2>3. License</h2>
        <p>We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial purposes on devices you own or control. You may not copy, modify, distribute, sell, or sublicense any part of the App.</p>

        <h2>4. User Accounts</h2>
        <p>You may be required to create an account to access certain features. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us immediately at <a href="mailto:support@lexira.app">support@lexira.app</a> if you suspect unauthorized use.</p>

        <h2>5. In-App Purchases</h2>
        <p>The App offers optional in-app purchases of virtual currency (coins) and items. All purchases are final and non-refundable except where required by applicable law. Virtual currency and items have no real-world monetary value and cannot be exchanged for cash.</p>

        <h2>6. Virtual Currency &amp; Rewards</h2>
        <p>Coins, hints, spins, and other in-game items are virtual goods with no monetary value. We reserve the right to modify, suspend, or remove any in-game items or rewards at any time without notice.</p>

        <h2>7. Prohibited Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use cheats, bots, automation software, or any unauthorized third-party software.</li>
          <li>Reverse-engineer, decompile, or disassemble the App.</li>
          <li>Interfere with or disrupt the App's servers or networks.</li>
          <li>Harass or harm other users.</li>
          <li>Use the App for any illegal purpose.</li>
        </ul>

        <h2>8. Intellectual Property</h2>
        <p>All content in the App — including but not limited to text, graphics, mascot characters, level designs, audio, and code — is the exclusive property of Lexira and its licensors and is protected by copyright and other intellectual property laws.</p>

        <h2>9. Disclaimer of Warranties</h2>
        <p>The App is provided "as is" without warranties of any kind, express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>

        <h2>10. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, Lexira and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the App.</p>

        <h2>11. Changes to Terms</h2>
        <p>We may update these Terms at any time. We will notify you of material changes via the App or email. Continued use of the App after changes constitutes your acceptance of the new Terms.</p>

        <h2>12. Governing Law</h2>
        <p>These Terms are governed by the laws of the jurisdiction in which the developer is domiciled, without regard to conflict-of-law principles.</p>

        <h2>13. Contact</h2>
        <p>Questions about these Terms? Email us at <a href="mailto:support@lexira.app">support@lexira.app</a>.</p>
      </div>
    </div>
  );
}
